module.exports = __webpack_public_path__ + "4621ebc263a89d27adc27d12de032c7b.pdf";